import { Validator } from "@components/form/validation/Validator";

const validator = new Validator();
export const pinLengthSchema = validator.string().requiredLength(6, {
  message: "Pin code length should be 6 characters."
});
